import { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchRecords from '../../medicine/SearchRecords';
import {
    Box,
    Container,
    Grid,
    Card
} from '@mui/material';
import { _axios } from 'src/plugins/axios';
import { DateUtils } from 'src/utils/dateUtils';
import commonService from 'src/service/common';
import PHSResultView from './PHSResultView';

class PHSLeaderboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: {
                dateRange: []
            },
            filterOptions: {
                entityRequested: []
            },
            hideEntityRequested: true,
            bookedRequests: [],
            fulfilmentRequests: []
        }
    }

    componentDidMount = async () => {
        await this.getBookedPHSRequests({});
        await this.getFulfilmentPHSRequests({});
    }

    applyFilters = async () => {
        const payload = {};
        if (this.state.filter.dateRange.length == 2) {
            let startDate = new Date(this.state.filter.dateRange[0]);
            let endDate = new Date(this.state.filter.dateRange[1]);
            payload['apptDateBegin'] =
                startDate.getFullYear() +
                '-' +
                ('0' + (startDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + startDate.getDate()).slice(-2);
            payload['apptDateEnd'] =
                endDate.getFullYear() +
                '-' +
                ('0' + (endDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + endDate.getDate()).slice(-2);
        }

        await this.getBookedPHSRequests(payload);
        await this.getFulfilmentPHSRequests(payload);
    }

    getBookedPHSRequests = async (payload) => {
        //setting Default payload
        if (Object.keys(payload).length == 0) {
            payload = {
                ...payload,
                apptDateBegin: DateUtils.getCurrentYearStartDate(),
                apptDateEnd: DateUtils.getDate()
            }
        }

        payload.typeOfRequests = 'booked';

        _axios.post('/ahc/phsRequests', payload, {
            ignoreLoading: false,
            timeout: 120000,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response?.data?.isSuccess) {
                this.setState({
                    bookedRequests: response?.data?.result
                });
            }
        }).catch(err => {
            console.log(err.message);
        })
    }

    getFulfilmentPHSRequests = async (payload) => {
        //setting Default payload
        if (Object.keys(payload).length == 0) {
            payload = {
                ...payload,
                apptDateBegin: DateUtils.getCurrentYearStartDate(),
                apptDateEnd: DateUtils.getDate()
            }
        }

        payload.typeOfRequests = 'fulfilled';

        _axios.post('/ahc/phsRequests', payload, {
            ignoreLoading: false,
            timeout: 120000,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response?.data?.isSuccess) {
                this.setState({
                    fulfilmentRequests: response?.data?.result
                });
            }
        }).catch(err => {
            console.log(err.message);
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>AHC | PHS Leaderboard</title>
                </Helmet>
                <Box
                    sx={{
                        backgroundColor: 'background.default',
                        minHeight: '100%',
                        py: 2
                    }}
                >
                    <Container maxWidth={false}>
                        <SearchRecords
                            filterOptions={this.state.filterOptions}
                            filter={this.state.filter}
                            hideEntityRequested={this.state.hideEntityRequested}
                            setFilters={(value) => this.setState({ filter: value })}
                            onRefresh={() => this.applyFilters()}
                        />
                    </Container>

                    <div className='to-noteContainer' style={{
                        marginTop: 30,
                        marginBottom: 20
                    }}>
                        <div className='to-noteHeader phs-note'>Note: Default date range is 21st August 2023 till current date. Please select the date filters to view the data for specific date range only.</div>
                        <div className='to-noteHeader'>Please note: The date filter will apply on Booking date for Requests booked dashboard, while it will apply on the fulfilment date for Requests Fulfilled Dashboard</div>
                    </div>

                    <Container maxWidth={false}>
                        <Grid container>
                            <Grid item xs={6}>
                                <Card
                                    sx={{
                                        width: '100%',
                                        borderRadius: 4,
                                        mb: 2,
                                        p: 3,
                                        boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                                    }}
                                >
                                    < PHSResultView
                                        data={this.state.bookedRequests}
                                        typeOfRequests='booked'
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={6}>
                                <Card
                                    sx={{
                                        width: '100%',
                                        borderRadius: 4,
                                        mb: 2,
                                        p: 3,
                                        boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)',
                                        ml: 2
                                    }}
                                >
                                    < PHSResultView
                                        data={this.state.fulfilmentRequests}
                                        typeOfRequests='fulfilment'
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Container>

                </Box>

            </>
        );
    }
}

export default PHSLeaderboard;